var _path, _path2, _path3, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 30,
    viewBox: "0 0 35 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4565_214950)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.7954 3.27783H8.24213C6.89057 3.27783 5.79663 4.37177 5.79663 5.72333V24.2727C5.79663 25.6242 6.89057 26.7182 8.24213 26.7182H14.6829L17.9607 29.996L21.2386 26.7182H26.7915C28.143 26.7182 29.237 25.6242 29.237 24.2727V5.72333C29.237 4.37177 28.143 3.27783 26.7915 3.27783H26.7954Z",
    fill: "url(#paint0_linear_4565_214950)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5188 6.29019V4.8435C32.5188 2.16811 30.3508 -0.00390625 27.6714 -0.00390625H7.36229C4.6869 5.72852e-05 2.51885 2.16811 2.51885 4.84746V6.29415C1.54778 6.53196 0.826416 7.39998 0.826416 8.44239V21.5657C0.826416 22.6081 1.54778 23.4761 2.51885 23.7139V25.1606C2.51885 27.836 4.6869 30.008 7.36625 30.008H13.4939C13.6881 30.008 13.8625 29.9485 14.0012 29.8494C14.4174 29.5561 14.5323 28.918 14.1161 28.5018C14.0646 28.4503 14.0091 28.4067 13.9497 28.371C13.8149 28.2878 13.6564 28.2442 13.4939 28.2442H7.36625C5.66193 28.2442 4.28262 26.8649 4.28262 25.1606V4.84746C4.28262 3.14314 5.66193 1.76383 7.36625 1.76383H27.6754C29.3797 1.76383 30.759 3.14314 30.759 4.84746V25.1566C30.759 26.8609 29.3797 28.2402 27.6754 28.2402H22.4316C22.2969 28.2402 22.1661 28.272 22.0472 28.3274C21.96 28.371 21.8768 28.4265 21.8054 28.4979C21.4923 28.811 21.4804 29.247 21.6706 29.568C21.8173 29.8177 22.0868 30.0001 22.4277 30.0001H27.6714C30.3468 30.0001 32.5188 27.832 32.5188 25.1527V23.706C33.4899 23.4682 34.2113 22.6001 34.2113 21.5577V8.43843C34.2113 7.39601 33.4899 6.528 32.5188 6.29019Z",
    fill: "url(#paint1_linear_4565_214950)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M25.5231 7.94292H9.51443C9.30833 7.94292 9.11411 7.88743 8.95161 7.79231C8.61074 7.5981 8.38086 7.22949 8.38086 6.80935C8.38086 6.53191 8.47995 6.27824 8.64642 6.08006C8.85252 5.83432 9.16564 5.67578 9.51443 5.67578H25.5192C25.8323 5.67578 26.1137 5.80261 26.3198 6.00872C26.5259 6.21482 26.6528 6.49623 26.6528 6.80935C26.6528 7.03924 26.5854 7.2493 26.4704 7.42766C26.2683 7.73682 25.9195 7.94292 25.5231 7.94292Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M26.7955 3.27783H8.24219C6.89062 3.27783 5.79669 4.37177 5.79669 5.72333V24.2727C5.79669 25.6242 6.89062 26.7182 8.24219 26.7182H14.6829L17.9608 29.996L21.2386 26.7182H26.7915C28.1431 26.7182 29.237 25.6242 29.237 24.2727V5.72333C29.237 4.37177 28.1431 3.27783 26.7915 3.27783H26.7955ZM28.0678 24.2766C28.0678 24.9782 27.497 25.5489 26.7955 25.5489H20.7551L17.9608 28.3432L15.1665 25.5489H8.24219C7.54064 25.5489 6.9699 24.9782 6.9699 24.2766V5.72333C6.9699 5.02179 7.54064 4.45104 8.24219 4.45104H26.7915C27.4931 4.45104 28.0638 5.02179 28.0638 5.72333V24.2727L28.0678 24.2766ZM14.1161 28.4978C14.5323 28.914 14.4134 29.5521 14.0012 29.8454C13.8625 29.9445 13.6921 30.0039 13.4939 30.0039H7.36625C4.69086 30.0039 2.51885 27.8359 2.51885 25.1565V23.7099C1.54778 23.472 0.826416 22.604 0.826416 21.5616V14.8593C1.92035 15.3508 3.07374 15.7986 4.27866 16.191V25.1565C4.27866 26.8609 5.65797 28.2402 7.36229 28.2402H13.4899C13.6524 28.2402 13.811 28.2838 13.9457 28.367C14.0052 28.4027 14.0607 28.4463 14.1122 28.4978H14.1161ZM30.759 16.191V25.1565C30.759 26.8609 29.3797 28.2402 27.6754 28.2402H22.4316C22.2969 28.2402 22.1661 28.2719 22.0472 28.3274C21.96 28.371 21.8768 28.4265 21.8054 28.4978C21.4923 28.8109 21.4804 29.2469 21.6706 29.568C21.8173 29.8177 22.0868 30 22.4277 30H27.6714C30.3468 30 32.5188 27.8319 32.5188 25.1526V23.7059C33.4899 23.4681 34.2113 22.6001 34.2113 21.5577V14.8553C33.1173 15.3468 31.9639 15.7947 30.759 16.1871V16.191Z",
    fill: "url(#paint2_linear_4565_214950)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M17.5169 18.2047C13.3314 18.2047 9.35991 17.6419 5.79272 16.6431V24.2729C5.79272 25.6244 6.88666 26.7184 8.23823 26.7184H14.679L17.9568 29.9962L21.2347 26.7184H26.7876C28.1391 26.7184 29.2331 25.6244 29.2331 24.2729V16.6431C25.6659 17.6419 21.6984 18.2047 17.5089 18.2047H17.5169Z",
    fill: "url(#paint3_linear_4565_214950)"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_4565_214950)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.3192 9.4375H25.9897L20.1261 14.4448L26.9767 21.2373H21.6007L17.3917 17.1095L12.5731 21.2373H9.90253L16.1145 15.8817L9.5542 9.4375H15.0637L18.8663 13.2082L23.3192 9.4375ZM22.3845 20.0617H23.8649L14.2857 10.5696H12.695L22.3845 20.0617Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4565_214950",
    x1: 5.79663,
    y1: 16.6389,
    x2: 29.2409,
    y2: 16.6389,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#050404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D797B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4565_214950",
    x1: 0.826416,
    y1: 14.9981,
    x2: 34.2113,
    y2: 14.9981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#050404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D797B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4565_214950",
    x1: 0.826416,
    y1: -0.0000123407,
    x2: 34.2113,
    y2: -0.0000123407,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#050404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D797B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4565_214950",
    x1: 0.826415,
    y1: 23.3216,
    x2: 1.22277,
    y2: 23.3216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#050404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D797B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4565_214950"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33.3849,
    height: 30,
    fill: "white",
    transform: "translate(0.826416)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_4565_214950"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.4167,
    height: 11.7998,
    fill: "white",
    transform: "translate(9.61804 9.4375)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.99baaaeddc353f0064aab64534e6f9da.svg";
export { ForwardRef as ReactComponent };